import {
    getFleetPo,
    getConsolidatedFleetPo
  } from "./FleetProcessingAction";

  const dispatchGetFleetPo = (dispatch: Function) => (data: any) => {
    dispatch(getFleetPo(data));
  };

  const dispatchGetConsolidatedFleetPo = (dispatch: Function) => (data: any) => {
    dispatch(getConsolidatedFleetPo(data));
  };

  const FleetProcessingDispatch = {
    dispatchGetFleetPo,
    dispatchGetConsolidatedFleetPo
    };

export default FleetProcessingDispatch